import DefaultButton from "./DefaultButton";
export default DefaultButton;
